import { render, staticRenderFns } from "./SonarForm.vue?vue&type=template&id=fa7212be&scoped=true"
import script from "./SonarForm.vue?vue&type=script&lang=js"
export * from "./SonarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7212be",
  null
  
)

export default component.exports